import errors from './errors/index.js';
import translation from './translation/index.js';
const trTR = Object.freeze({
    translation,
    errors,
});
export default trTR;
